import { axiosClient } from '../api-client'
import Pathes from '@App/dicts/pathes'
import { AxiosResponse } from 'axios'
import { TokenResponse } from '@Entities/auth/token-response'

export const logOut = async (): Promise<void> => axiosClient.post(Pathes.Auth.logOut)

export const login = async (body: object): Promise<AxiosResponse<TokenResponse>> =>
    axiosClient.post(Pathes.Auth.signIn, body)

export const mfaSubmit = async (body: object): Promise<AxiosResponse<TokenResponse>> =>
    axiosClient.post(Pathes.Auth.mfaSubmit, body)

export const forgotPassword = async (username: string) => axiosClient.post(Pathes.Auth.forgotPassword, { username })

export const confirmForgotPassword = async (username: string, confirmationCode: string, newPassword: string) =>
    axiosClient.post(Pathes.Auth.confirmForgotPassword, { username, confirmationCode, newPassword })
